<script>
export default {
  name: 'file-icon',
  props: {
    contentType: { type: String }
  },
  computed: {
    icon () {
      let icon = 'far fa-file'
      if (this.contentType.match('application/pdf')) icon = 'far fa-file-pdf'
      else if (this.contentType.match('image.*')) icon = 'far fa-file-image'
      else if (this.contentType.match('application/json'))
        icon = 'far fa-file-code'
      else if (this.contentType.match('audio.*')) icon = 'far fa-file-audio'
      else if (this.contentType.match('video.*')) icon = 'far fa-file-video'
      else if (this.contentType.match('application/vnd.ms-powerpoint'))
        icon = 'far fa-file-powerpoint'
      else if (this.contentType.match('application/msword'))
        icon = 'far fa-file-word'
      else if (this.contentType.match('application/vnd.ms-excel'))
        icon = 'far fa-file-excel'
      else if (this.contentType.match('application/x-zip-compressed'))
        icon = 'far fa-file-archive'
      return icon
    }
  }
}
</script>
<template>
  <i :class="icon" />
</template>
